import { render, staticRenderFns } from "./ProtoScore.vue?vue&type=template&id=4599f6b6&scoped=true"
import script from "./ProtoScore.vue?vue&type=script&lang=js"
export * from "./ProtoScore.vue?vue&type=script&lang=js"
import style0 from "./ProtoScore.vue?vue&type=style&index=0&id=4599f6b6&prod&lang=scss"
import style1 from "./ProtoScore.vue?vue&type=style&index=1&id=4599f6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4599f6b6",
  null
  
)

export default component.exports